<template lang="pug">
section.section.section-background-grey.border-bottom-section
	.section-content
		.columns.is-centered.is-vcentered
			.column.is-narrow.has-text-centered
				img(src="/icon-big.png" style="width: 100px;display:inline-block;")
			.column.has-text-centered-md
				.title.is-spaced(style="margin-bottom: .5rem;")
					| {{ $t('about.title_start_workout') }}
				//-p.subtitle(style="margin-bottom: .5rem;")
					| {{ $t('about.solutions_from') }}
				p.subtitle(style="margin-bottom: .5rem;")
					| {{ $t('about.solutions_languages') }}
			.column.is-narrow
				p.subtitle.has-text-centered(style="margin-bottom: .5rem;")
					| {{ $t('about.download_app') }}
				.app-container.justify-center-md(style="justify-content:flex-end;")
					android-app
					ios-app
</template>

<script>
import AndroidApp from '../app/AndroidApp.vue'
import IosApp from '../app/IosApp.vue'

export default {
	components: {
		AndroidApp,
		IosApp
	},
	name: 'SectionFooterSolution'
}
</script>
